var icon = require('vue-svgicon')
icon.register({
  'ks-icon-cancel': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M65 22a42 42 0 1 0 42 42 42 42 0 0 0-42-42zm19.53 37l-8.69 1.38v-7.09H52.43v23.62h23.41v-8l8.69 1.8v4.41c0 3.42-.64 5.74-1.92 7s-3.73 1.85-7.33 1.85H53q-5.43 0-7.34-1.85c-1.27-1.24-1.91-3.56-1.91-7V55.44q0-5.09 1.91-6.95T53 46.61h22.28q5.4 0 7.33 1.88t1.92 6.95z"/>'
  }
})
